// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"5a8ac818","348":"1169297e"}[chunkId] + ".js";
};